import Vue from 'vue'
import VueRouter from 'vue-router'
import ResetPassword from '../views/ResetPassword.vue'
import ConfirmAccount from '../views/ConfirmAccount.vue'
import GoogleLogin from '../views/GoogleLogin.vue'

import EmailChange from '../views/EmailChange.vue'
import EmailConfirm from '../views/EmailConfirm.vue'

import SmsConfirm from '../views/SmsConfirm.vue'

Vue.use(VueRouter)

const routes = [
  { path: '/password-reset/:code', name: 'ResetPassword', component: ResetPassword },
  { path: '/email-change/:code', name: 'ChangeEmail', component: EmailChange },
  { path: '/email-confirm/:code', name: 'ConfirmEmail', component: EmailConfirm },
  { path: '/account-confirm/:code', name: 'ConfirmAccount', component: ConfirmAccount },
  { path: '/oauthlogin', name: 'GoogleLogin', component: GoogleLogin },
  { path: '/sms-confirm/:code', name: 'SmsConfirm', component: SmsConfirm },
]

const router = new VueRouter({
  routes
})

export default router
